import * as actions from "./actions";
import * as getters from "./getters";
import * as types from "./mutation_types";
import { clone } from "ramda";
import {
  mutation as fetchMutation,
  state as fetchState,
} from "@/store/fetchBase";
import { mutation as resetMutation } from "@/store/resetBase";

/** @type {Object} Initial state for the module */
export const initialState = {
  ...fetchState(),
};

export default {
  // Clone of the initialState to set to the module
  state: clone(initialState),

  // List of available module mutations
  mutations: {
    ...fetchMutation(types.FETCH),
    ...resetMutation(types.RESET, initialState),
  },

  // List of available module actions
  actions,

  // List of available module getters
  getters,

  // Add namespace into module
  namespaced: true,
};
